// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./components/CardList/CardList.less
// module id = 189
// module chunks = 2